module.exports = "<div users-wrapper page-class=\"users-login\">\n  <div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <h1>{{ \"USERS.NO_ACCOUNT.TITLE\" | translate }}</h1>\n\n    <!-- <div>\n      <img class=\"round\" alt=\"F&F\" src=\"http://placehold.it/200x200\">\n    </div> -->\n\n    <a ui-sref=\"public.users.forgot-email\">\n        {{ \"COMMONS.TRY_AGAIN\" | translate }}</a>\n\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/users/forgot-password/no-account.html
// module id = 248
// module chunks = 0